/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
// @flow

import type { Element } from 'react';

import React from 'react';
import { Col, FormGroup, Row } from 'reactstrap';
import {
  REGION_COST_MULTIPLIER,
  DATE_COST_MULTIPLIER,
  OCCUPANCY_COST_MULTIPLIER,
  BUILDING_VALUE_MODIFIER,
  COMPONENT_SOFT_COST_MODIFIER,
} from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import Tip from '#components/support/tooltips/Tip/index.jsx';

type Props = {|
  regionCostMultiplier: number,
  dateCostMultiplier: number,
  occupancyCostMultiplier: number,
  buildingValueModifier: number,
  componentSoftCostModifier: number,
|};

const RepairCostExposureScaleFactorsApplied = (props: Props): Element<'div'> => {
  const {
    regionCostMultiplier,
    dateCostMultiplier,
    occupancyCostMultiplier,
    buildingValueModifier,
    componentSoftCostModifier,
  } = props;
  return (
    <div id="repairCostExposureScaleFactorsApplied">
      <FormGroup tag="fieldset">
        <legend>Scale Factors Applied</legend>
        <Row>
          <Col lg="4">
            Region Cost Multiplier <Tip tipId={REGION_COST_MULTIPLIER} />
            {' :'}
          </Col>
          <Col lg="8">{regionCostMultiplier}</Col>
        </Row>
        <Row>
          <Col lg="4">
            Date Cost Multiplier <Tip tipId={DATE_COST_MULTIPLIER} />
            {' :'}
          </Col>
          <Col lg="8">{dateCostMultiplier}</Col>
        </Row>
        <Row>
          <Col lg="4">
            Occupancy Cost Multiplier <Tip tipId={OCCUPANCY_COST_MULTIPLIER} />
            {' :'}
          </Col>
          <Col lg="8">{occupancyCostMultiplier}</Col>
        </Row>
        <Row>
          <Col lg="4">
            Building Value Modifier <Tip tipId={BUILDING_VALUE_MODIFIER} />
            {' :'}
          </Col>
          <Col lg="8">{buildingValueModifier}</Col>
        </Row>
        <Row>
          <Col lg="4">
            Component Soft Cost Modifier <Tip tipId={COMPONENT_SOFT_COST_MODIFIER} />
            {' :'}
          </Col>
          <Col lg="8">{componentSoftCostModifier}</Col>
        </Row>
      </FormGroup>
    </div>
  );
};

export default RepairCostExposureScaleFactorsApplied;
